// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    MOST_CREATIVE_PEOPLE_COMMUNITY_SECTION_LOADING() {
      return {
        isLoading: true
      };
    },
    MOST_CREATIVE_PEOPLE_COMMUNITY_SECTION_LOADED() {
      return {
        isLoading: false,
        data: action.mostCreativePeopleCommunitySection
      };
    },
    MOST_CREATIVE_PEOPLE_COMMUNITY_SECTION_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.mostCreativePeopleCommunitySection.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
